import dayjs from "dayjs";
import { Month, MONTHS } from "./enums/DateEnum";

export function quarters() {
	const previousYear = dayjs().subtract(2, "year").year();
	const current = dayjs();
	const nextYear = dayjs().add(1, "year").year();

	const quarters = Array.from({ length: (current.year() + 1 - previousYear) * 3 }, (_, index) => {
		const indexQuarter = (index % 3) + 1;
		const previousQuarters = `Q${indexQuarter}/${previousYear + Math.floor(index / 3)}`;
		return previousQuarters;
	});

	const nextQuarter = `Q1/${nextYear}`;

	return [...quarters, nextQuarter].reverse();
}

export function getQuarterDates(
	quarterStr: string,
	format: string = "YYYY-MM-DDTHH:mm:ss.SSSZ"
): { startDate: string; endDate: string } {
	const match = RegExp(/^Q([1-3])\/(\d{4})$/).exec(quarterStr);
	if (!match) {
		throw new Error('Formato inválido. Use "Q{1-3}/{ano}", exemplo: "Q1/2025"');
	}

	const quad = parseInt(match[1], 10);
	const year = parseInt(match[2], 10);

	const startMonths = [0, 4, 8]; // jan, mai, set
	const endMonths = [3, 7, 11]; // abr, ago, dez

	const startMonth = startMonths[quad - 1];
	const endMonth = endMonths[quad - 1];

	const startDate = new Date(year, startMonth, 1);
	const endDate = new Date(year, endMonth + 1, 0, 23, 59, 59, 999);

	return {
		startDate: dayjs(startDate).format(format),
		endDate: dayjs(endDate).format(format),
	};
}

export function getMonthsFromQuarter(quarter: string): Month[] {
	const match = /^Q([1-3])\/\d{4}$/.exec(quarter);

	if (!match) return [];

	const quarterNumber = Number(match[1]);

	const startIndex = (quarterNumber - 1) * 4;
	const endIndex = startIndex + 4;

	return MONTHS.slice(startIndex, endIndex);
}
